<template>
<div class="form-submission-card-content-label">
    {{ question }}
</div>
</template>

<script>
export default {
    props: [
        'question',
    ],
}

</script>
